import {useContext, useEffect, useState} from 'react'
import {SalesRepTypeReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {parseSalesRepTypeReportRow} from '../../parsings'
import SalesRepTypeReportRow from './SalesRepTypeReportRow'
import {formatCountAndPrice, keysToSum, SALES_REP_TYPE_REPORT_COLUMNS} from '../../utils'
import {formatPrice, formatToIndianNumber} from '../../../../utils/common'

const SalesRepTypeReportTable = () => {
  const {
    salesRepTypeData,
    isSalesRepTypeLoading,
    onSalesRepTypeSortingChange,
    salesRepTypeFilters,
  } = useContext(SalesRepTypeReportContext)
  const [summedState, setSummedState] = useState<any>({})

  useEffect(() => {
    const summed: any = {}

    salesRepTypeData.forEach((row) => {
      keysToSum.forEach((key) => {
        const sumKey = `total_${key}`
        summed[sumKey] = (summed[sumKey] || 0) + (row[key] || 0)
      })
    })

    setSummedState(summed)
  }, [salesRepTypeData])

  return (
    <DynamicTable
      data={salesRepTypeData}
      sortableColumns={SALES_REP_TYPE_REPORT_COLUMNS}
      loading={isSalesRepTypeLoading}
      TableRow={SalesRepTypeReportRow}
      noDataMessage='No sales rep type reports found'
      onSortingChange={onSalesRepTypeSortingChange}
      filters={salesRepTypeFilters}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepTypeReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{formatToIndianNumber(columnTotals.total_order_count)}</td>
            <td>
              {formatCountAndPrice(
                summedState?.total_freeship_coupon_count,
                summedState?.total_freeship_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_sf_coupon_count,
                summedState?.total_sf_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_sll_coupon_count,
                summedState?.total_sll_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_5offoneorder_coupon_count,
                summedState?.total_5offoneorder_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_other_coupon_count,
                summedState?.total_other_discount
              )}
            </td>
            <td>{formatPrice(columnTotals.total_discount, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepTypeReportTable
